!((document, $) => {
  'use strict';

  $(document).ready(function() {
    if ($('.node-academic-article-form').length) {
      $('.block-system-title-combo .page-title').text(
        'Suggest an Academic Article'
      );
    }
  });
})(document, jQuery);
